import React from 'react';

import Button from 'react-bootstrap/Button';

import RevolvingMembershipCard from './RevolvingMembershipCard';

import { VerticalSeparator } from './utils';


export default function TelegramAppForMobileWithConfigProblem({ clearAppSecret }) {
    return (
        <>
            <RevolvingMembershipCard
                name='Member'
                cardId='00000000' />
            <VerticalSeparator />
            <div style={{ color: 'red', textAlign: 'center' }}>
                Unable to load member data.
            </div>
            <div style={{ color: 'red', textAlign: 'center' }}>
                Try again later.
            </div>
            <VerticalSeparator />
            <div style={{ color: 'red', textAlign: 'center' }}>
                If that doesn't work,
            </div>
            <div style={{ color: 'red', textAlign: 'center' }}>
                click <Button variant="outline-secondary" size="sm" onClick={clearAppSecret}>here</Button> to re-configure.
            </div>
        </>
    );
}

